import { Model } from '@app/shared/models/model.model';
import { EmailTemplate } from '@app/settings/templates/email-template.model';
import { User } from '@app/settings/users/user.model';
import { Events } from '@app/events/events/events.model';
import { Sale } from '@app/sales/sales/sale.model';

export class CampaignSale extends Model {
  id: number;
  campaign_id: number;
  sale_id?: number;
  sale?: Sale;
  new_sale_id?: number;
  newSale?: Sale;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.sale) {
      this.sale = new Sale().deserialize(input.sale);
    }

    if (input.newSale) {
      this.newSale = new Sale().deserialize(input.newSale);
    }

    return this;
  }
}

export class Campaign extends Model {
  id: number;
  creator_id: number;
  creator?: User;
  event_id: number;
  event?: Events;
  template_id: number;
  template?: EmailTemplate;
  sales: Array<CampaignSale>;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.creator) {
      this.creator = new User().deserialize(input.creator);
    }

    if (input.event) {
      this.event = new Events().deserialize(input.event);
    }

    if (input.sales) {
      this.sales = input.sales.map((campaignSale: CampaignSale) => new CampaignSale().deserialize(campaignSale));
    }

    return this;
  }
}
